import { Component, OnInit, ViewChild, EventEmitter } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { EventService } from "../../../../../../../modules/shared/services/event.service";
import { SharedService } from "../../../../../../../modules/shared/services/shared.service";
import { LoginConfigView } from "../login-config.view";

@Component({
    selector: "config-after-login",
    templateUrl: "./config-after-login.view.html",
    providers: []
})
export class ConfigAfterLoginSectionView extends LoginConfigView {
    allowedRegStatusList: any = [];

    // SCM-52036 :Session Catalog _ pre-filter changes moved to backlog
    // preFilterDropdownSettings: any = {
    //     singleSelection: false,
    //     idField: "orderIndex",
    //     textField: "name",
    //     selectAllText: "All",
    //     unSelectAllText: "All",
    //     allowSearchFilter: true,
    //     isDateSelector: false,
    //     searchPlaceholderText: "Enter search term..."
    // };

    constructor(
        public sharedService: SharedService,
        public activatedRoute: ActivatedRoute,
        public eventService: EventService
    ) {
        super(sharedService, activatedRoute, eventService);

        this.bodyConfig.regStatusConfigs?.forEach((savedConfig) => {
            this.allowedRegStatusList.push(savedConfig);
        });
    }

    // SCM-52036 :Session Catalog _ pre-filter changes moved to backlog
    // toggleHTMLEnable(e,type) {
    //     this.bodyConfig[type] = !this.bodyConfig[type];
    // }
}
